module.exports = __webpack_public_path__ + "static/media/choice3.f2b19273.png";